import { Button, Center, EmptyState, Table } from '@mantine/core';
import { IconListCheck, IconPlus } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { TaskTypeListItem, useLoadTaskTypes } from 'modules/Tasks';

type Props = {
  onCreate: () => void;
  actionLabel: string;
  isActive: boolean;
};

export const TaskTypes = ({ onCreate, actionLabel, isActive }: Props) => {
  const { t } = useTranslation();

  const { taskTypes, refetchTaskTypes, isTaskTypesInitialLoading } = useLoadTaskTypes();

  if (taskTypes.data.length === 0 && !isTaskTypesInitialLoading) {
    return (
      <Center my="xl" w="100%">
        <EmptyState
          icon={<IconListCheck size={48} stroke={1.5} />}
          title={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.TASK_TYPES_TITLE)}
          description={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.TASK_TYPES_DESCRIPTION)}
        >
          <EmptyState.Actions>
            <Button
              disabled={!isActive}
              rightSection={<IconPlus size={20} stroke={1.5} />}
              onClick={() => isActive && onCreate()}
            >
              {actionLabel}
            </Button>
          </EmptyState.Actions>
        </EmptyState>
      </Center>
    );
  }

  return (
    <Table verticalSpacing="xs" striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>{t(i18nKeys.SETTINGS.TASKS.TASK_ID)}</Table.Th>
          <Table.Th>{t(i18nKeys.SETTINGS.TASKS.TASK_VALUE)}</Table.Th>
          <Table.Th>{t(i18nKeys.CREATION)}</Table.Th>
          <Table.Th w={100}>{t(i18nKeys.FORM.ACTIONS)}</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {taskTypes.data.map(item => (
          <TaskTypeListItem key={item.id} item={item} refetch={refetchTaskTypes} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
